export default __webpack_public_path__ + "media/zurb/img/case-study-paysa/paysa-video-9fa5c99a2ea9dac0c86e36656925f563.png";